import { canUseLocalStorage } from "@/utils/canuseLocalStorage";

/**
 * 首次登录状态管理器
 * 负责管理首次登录状态，提供获取、更新等功能
 * @author 杨俊朗
 */
export class IamFirstLoginManager {
  private static instance: IamFirstLoginManager;
  private readonly storageKey = "MIUTA_FIRST_LOGIN";
  private firstLoginState: boolean = false;

  private constructor() {
    this.init();
  }

  /**
   * 获取单例实例
   */
  static getInstance(): IamFirstLoginManager {
    if (!IamFirstLoginManager.instance) {
      IamFirstLoginManager.instance = new IamFirstLoginManager();
    }
    return IamFirstLoginManager.instance;
  }

  /**
   * 初始化 - 从 localStorage 读取首次登录状态
   */
  private init(): void {
    if (canUseLocalStorage()) {
      const stored = localStorage.getItem(this.storageKey);
      try {
        this.firstLoginState = stored ? stored === "true" : false;
      } catch (error) {
        console.error(
          "Failed to parse first login state from localStorage:",
          error
        );
        this.firstLoginState = false;
      }
    }
  }

  /**
   * 更新首次登录状态
   */
  update(value: boolean): void {
    console.log("update first login state", value, import.meta.url);
    this.firstLoginState = value;

    // 存储到 localStorage
    if (canUseLocalStorage()) {
      if (value) {
        localStorage.setItem(this.storageKey, String(value));
      } else {
        localStorage.removeItem(this.storageKey);
      }
    }
  }

  /**
   * 获取当前首次登录状态
   */
  get(): boolean {
    return this.firstLoginState;
  }

  /**
   * 清除首次登录状态
   */
  clear(): void {
    this.update(false);
  }
}

// 创建单例实例
export const iamFirstLoginManager = IamFirstLoginManager.getInstance();
